<div class="container">
    <div class="row">
        <div class="col-sm-12 mt-2 word-wrap">
            <h4 [innerHtml]="cplItem.Title"></h4><hr>
        </div>
    </div>
    <compliance-item-summary [complianceItem]="cplItem" [printMode]="true"></compliance-item-summary>
    <div class="row">
        <div class="col-sm-12">
            <table class="print-table table table-bordered" style="margin-top: 25px;">
                <thead>
                <tr>
                    <th class="fit no-wrap">Name</th>
                    <th>Status</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th *ngIf="isAct48Enabled() && cplItem.Act48Detail.ParaApplicable">Para Applicable</th>
                    <th *ngIf="isAct48Enabled()">Act 48 Hours/Credits</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let cplCycle of itemCycles?.Results">
                    <td class="fit no-wrap">{{cplCycle.LastName + ', ' + cplCycle.FirstName}}</td>
                    <td class="fit no-wrap">{{complianceItemHelpersService.userStatusToString(cplCycle.UserStatus)}}</td>
                    <td class="fit no-wrap">{{ DateHelpers.validDate(cplCycle.StartDate) | date: 'MM/dd/yyyy' | emptyString }}</td>
                    <td class="fit no-wrap">{{ DateHelpers.validDate(cplCycle.EndDate) | date: 'MM/dd/yyyy' | emptyString }}</td>
                    <td *ngIf="isAct48Enabled() && cplItem.Act48Detail.ParaApplicable" class="fit no-wrap">
                        <i *ngIf="cplCycle.IsPara" class="fas fa-check" aria-hidden="true"></i>
                    </td>
                    <td *ngIf="isAct48Enabled()" class="fit no-wrap">{{this.a48HelpersService.getHoursOrCreditsLabel(cplCycle.A48Hours, cplCycle.A48ActivityType)}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>